export const ITEM_ICON = 'icon-templates-stack';
export const ITEM_LABEL_KEY = 'pmwjs_layer_item';
export const GROUP_ICON = 'icon-templates-stack';
export const GROUP_LABEL_KEY = 'pmwjs_group';

export const GROUP_HEADER_ROW_PREFIX = 'group-';

export interface LayerItemEntry {
  layerType: 'item';
  uid: string;
}

export interface LayerGroupEntry {
  layerType: 'group';
  groupId: string;
  memberUids: string[];
}

export type LayerEntry = LayerItemEntry | LayerGroupEntry;

export type DraggedLayer = {layerType: 'item'; uid: string} | {layerType: 'group'; entry: LayerGroupEntry};
